// extracted by mini-css-extract-plugin
export var menuIcon = "_lj-0";
export var menuIconInline = "_lj-1";